import React from "react"
import styled from "styled-components"

import TitleHeader from "components/presenters/header/TitleHeader"
import CommerceChallengeTutorialList from "components/presenters/commerce/tutorial/CommerceChallengeTutorialList"
export default function CommerceTutorialLayout() {
	return (
		<MainLayout>
			<HeaderWrapper>
				<TitleHeader title={"모티샵 이용방법"} isCloseBtn={true} />
			</HeaderWrapper>
			<BodyWrapper>
				<CommerceChallengeTutorialList />
			</BodyWrapper>
		</MainLayout>
	)
}
const MainLayout = styled.div`
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: hidden;
`

const HeaderWrapper = styled.div`
	flex: 0 1 auto;
	min-height: calc(100vw * (59.68 / 375));
	height: calc(100vw * (60 / 375));
`

const BodyWrapper = styled.div`
	flex: 1 1 auto;
	height: 100%;
	overflow-y: scroll;
	padding: calc(100vw * (30 / 375)) calc(100vw * (20 / 375)) 0;
`
